<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
      <div class="d-sm-flex align-items-center">
        <div class="form-group mb-15 mb-sm-20 mb-md-25">
          <label class="d-block text-black fw-semibold mb-10"> Mot clé </label>
          <Field v-model="motCle" name="mot" type="text" aria-disabled="true"
            class="form-control shadow-none fs-md-15 text-black" placeholder="Recherche par mot clé" />
          <ErrorMessage name="mot" class="text-danger" />
        </div>
      </div>
      <!-- <div class="d-sm-flex align-items-center">
          <a href="#" data-bs-toggle="modal"
            class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none"
            data-bs-target="#AddUsagerModal" @click="ajouterUsager" type="button">
            Nouvel usager
            <i class="flaticon-plus position-relative ms-5 fs-12"></i></a>
        </div>-->
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="col-md-12">
      </div>
      <hr />
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Code
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Libellé
              </th>

              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0">
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(secteur, index) in secteurs" :key="index">
              <td class="shadow-none lh-1 fw-medium text-primary">
                {{ secteur.code_secteur }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-primary">
                {{ secteur.libelle_secteur }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-end pe-0 sm">
                <div class="dropdown">
                  <span class="badge text-white bg-secondary fs-15 dropdown-toggle" data-bs-toggle="dropdown"
                    aria-expanded="false">
                    Actions
                    <i class="flaticon-chevron-2 position-relative ms-5 top-2 fs-15"></i>
                  </span>
                  <ul class="dropdown-menu">
                    <li>
                      <a class="dropdown-item d-flex align-items-center" @click="imprimerAttestation(secteur)"
                        type="button"><i class="flaticon-view lh-1 me-8 position-relative top-1"></i>
                        Imprimer attestation des usagers
                      </a>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
            <tr v-if="secteurs.length === 0">
              <td colspan="3" class="text-center">Aucun secteur trouvé</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center">
        <PaginationComponent :page="page" :totalPages="totalPages" :totalElements="totalElements" :limit="limit"
          @paginate="handlePaginate" />
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { ref, defineComponent, onMounted, watch } from "vue";
import { Form, Field, ErrorMessage } from "vee-validate";
import {
  error,
  success,
  afficher20Caracteres,
} from "@/utils/utils";
import { Contrat } from "@/models/Contrat";
import ApiService from "@/services/ApiService";
import { Option } from "@/models/Option";
import PaginationComponent from "@/components/Utilities/Pagination.vue";
import JwtService from "@/services/JwtService";
import axios from "axios";
import Swal from "sweetalert2";

export default defineComponent({
  name: "ListeSecteur",
  components: {
    PaginationComponent,
    Field,
    ErrorMessage,
  },
  setup: () => {
    const secteurs = ref<any[]>([]);
    const page = ref(1);
    const limit = ref(10);
    const totalPages = ref(0);
    const totalElements = ref(0);
    const motCle = ref("");
    const handlePaginate = ({ page_, limit_ }) => {
      try {
        page.value = page_;
        limit.value = limit_;
        actionRecherche();
      } catch (error) {
        //
      }
    };
    const getUrlApiForFiles = (dossier: string | null, nomFichier: string | null) => {
      if (dossier) {
        const url = `${ApiService.vueInstance.axios.defaults["updateUrl"]}uploads/${dossier}/${nomFichier}`;
        return url;
      } else {
        return `${ApiService.vueInstance.axios.defaults["updateUrl"]}uploads/Erreur404.pdf`;
      }
    }
    const openAndPrint = (url: string) => {
      const newWindow = window.open(url, "_blank");

      if (newWindow) {
        newWindow.onload = () => {
          newWindow.print();
        };
      } else {
        console.error("Impossible d'ouvrir la fenêtre");
      }
    };
    const openNewWindow = async (data: any) => {
      await openAndPrint(getUrlApiForFiles("PointUsager", data.reference + ".pdf"));
    }
    const imprimerAttestation = async (secteur: any) => {
      Swal.fire({
        title: 'Veuillez patienter',
        html: 'Chargement en cours...',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      try {
        const donne = {
          secteur: secteur.code_secteur,
        };
        const recupererNombreTotoal = await axios.post("getNombreTotal",donne);
        const nombre = recupererNombreTotoal.data.data;
        var tableau = ref<Array<any>>([])

        if(recupererNombreTotoal.data.data > 200){
          const page = nombre/100
          var niveau = 0
          for(let i = 0 ; i<page; i++){
            const limit = 100;
            const ofset = ((i) * (limit)) - limit;
            donne["ofset"]=ofset;
            donne["page"]=i;
            donne["limit"]=100;
            const response = await axios.post("getPointUsagerEnLot", donne, {
              timeout: 3600000 // 1 heure en millisecondes
            });
            if (response.data.code == 200) {
              const reference = response.data.data;
              tableau.value.push(reference);
              const url = getUrlApiForFiles("PointUsager", response.data.data);
              openNewWindow({ reference });
            }
          }
        }else{
            donne["page"]=0;
            donne["limit"]=200;
          const response = await axios.post("getPointUsagerEnLot", donne, {
                timeout: 3600000 // 1 heure en millisecondes
              });
          if (response.data.code == 200) {
            const reference = response.data.data;
            const url = getUrlApiForFiles("PointUsager", response.data.data);
            openNewWindow({ reference });
          }
        }

       
       
        // console.log("response ==> ", response)
        // if (response.data.code == 200) {
        //   const reference = response.data.data;
        //   const url = getUrlApiForFiles("PointUsager", response.data.data);
        //   openNewWindow({ reference });
        // }
      } catch (err) {
        error("Erreur lors de la récupération des attesattions.");
      } finally {
        Swal.close();
      }
    }

    const actionRecherche = async () => {
      const donne = {
        page: page.value,
        limit: limit.value,
        mot: motCle.value,
      };
      try {
        const response = await ApiService.post(`liste/secteur`, donne);
        if (response.data.code == 200) {
          secteurs.value = response.data.data.data;
          totalPages.value = response.data.data.totalPages;
          totalElements.value = response.data.data.totalElements;
        } else {
          error(response.data.message);
        }
      } catch (err) {
        error("Erreur lors de la récupération des données.");
      }
    };

    watch(motCle, () => {
      page.value = 1;
      actionRecherche();
    });

    onMounted(async () => {
      await actionRecherche();
    });
    return {
      secteurs,
      page,
      limit,
      totalPages,
      totalElements,
      motCle,
      actionRecherche,
      afficher20Caracteres,
      handlePaginate,
      imprimerAttestation
    };
  },
});
</script>